import api from './api';

// Get message templates
export const getMessageTemplates = async () => {
  try {
    // console.log('Fetching templates from API');
    const response = await api.get('/templates', {
      // 換網域後新後端與舊機房 DB 跨網路傳輸，messagetemplates 回應整包含
      // ~14MB base64（LOGO + 簽名 + 印章）在 5s 內回不來，前端 timeout 後
      // 連鎖造成 Header LOGO 走文字 fallback、公司基本資料頁顯示無法載入。
      // 先拉到 60s 擋住；治本要把圖拆出來存到物件儲存 / 獨立檔。
      timeout: 60000
    });
    // console.log('Received templates from API:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching message templates:', error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to fetch templates: ${errorMessage}`);
  }
};

// Update message templates
export const updateMessageTemplates = async (templatesData) => {
  try {
    // Log size of base64 images 
    const logImageSize = (data) => {
      if (data.companyLogoBase64) {
        console.log('Logo image size:', Math.round(data.companyLogoBase64.length / 1024), 'KB');
      }
      if (data.companySignatureBase64) {
        console.log('Signature image size:', Math.round(data.companySignatureBase64.length / 1024), 'KB');
      }
      if (data.companyStampBase64) {
        console.log('Stamp image size:', Math.round(data.companyStampBase64.length / 1024), 'KB');
      }
    };
    
    logImageSize(templatesData);
    console.log('Sending templates update to API');
    
    // Make a copy of the data and ensure updatedAt is set
    const dataToSend = {
      ...templatesData,
      updatedAt: new Date().toISOString()
    };
    
    const response = await api.put('/templates', dataToSend, {
      timeout: 30000, // 30 second timeout for large image uploads
      maxContentLength: Infinity, // Allow large content size
      maxBodyLength: Infinity // Allow large body size
    });
    
    console.log('Templates updated successfully!');
    return response.data;
  } catch (error) {
    console.error('Error updating message templates:', error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to update templates: ${errorMessage}`);
  }
};

// Reset message templates to defaults
export const resetMessageTemplates = async () => {
  try {
    console.log('Requesting templates reset');
    const response = await api.post('/templates/reset', {}, {
      timeout: 5000 // 5 second timeout
    });
    console.log('Reset response from API:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error resetting message templates:', error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to reset templates: ${errorMessage}`);
  }
};
